import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { SyllabusLevel, SyllabusLevelResource } from '../../_models';

@Injectable({
  providedIn: 'root'
})
export class SyllabusLevelService {
  private apiUrl = `${environment.apiUrl}/SyllabusLevel`;
  constructor(private http: HttpClient) {
  }



  getBySubjectIdAndSectionSubjectIdForView(subjectId: number, sectionSubjectId: number): Observable<SyllabusLevel[]> {
    return this.http.get<SyllabusLevel[]>(`${this.apiUrl}/GetBySubjectIdAndSectionSubjectIdForView/${subjectId}${sectionSubjectId ? '/' + sectionSubjectId : ''}`);
  }


  addSyllabusLevel(syllabusLevel: SyllabusLevel): Observable<SyllabusLevel> {
    return this.http.post<SyllabusLevel>(`${this.apiUrl}/AddSyllabusLevel`, syllabusLevel);
  }

  updateSyllabusLevel(syllabusLevel: SyllabusLevel): Observable<SyllabusLevel> {
    return this.http.put<SyllabusLevel>(`${this.apiUrl}/UpdateSyllabusLevel`, syllabusLevel);
  }

  updateSyllabusLevelItemsAndResources(syllabusLevel: SyllabusLevel): Observable<SyllabusLevel> {
    return this.http.put<SyllabusLevel>(`${this.apiUrl}/UpdateSyllabusLevelItemsAndResources`, syllabusLevel);
  }

  updateSyllabusLevelObjectives(syllabusLevel: SyllabusLevel): Observable<SyllabusLevel> {
    return this.http.put<SyllabusLevel>(`${this.apiUrl}/UpdateSyllabusLevelObjectives`, syllabusLevel);
  }
  deleteSyllabusLevel(syllabusLevelId: number): Observable<SyllabusLevel> {
    return this.http.delete<SyllabusLevel>(`${this.apiUrl}/DeleteSyllabusLevel/${syllabusLevelId}`);
  }

  addSyllabusLevelResource(syllabusLevelResource: SyllabusLevelResource): Observable<SyllabusLevelResource> {
    const formData: FormData = new FormData();
    formData.append('syllabusLevelResourceId', syllabusLevelResource.syllabusLevelResourceId + '');
    formData.append('syllabusLevelId', syllabusLevelResource.syllabusLevelId + '');
    formData.append('sectionSubjectId', syllabusLevelResource.sectionSubjectId ? syllabusLevelResource.sectionSubjectId + '' : '');
    formData.append('type', syllabusLevelResource.type + '');
    formData.append('title', syllabusLevelResource.title ? syllabusLevelResource.title : '');
    formData.append('fileName', syllabusLevelResource.fileName ? syllabusLevelResource.fileName : '');
    if (syllabusLevelResource.file)
      formData.append('file', syllabusLevelResource.file, syllabusLevelResource.file.name);
    return this.http.post<SyllabusLevelResource>(`${this.apiUrl}/AddSyllabusLevelResource`, formData);
  }

  deleteSyllabusLevelResource(syllabusLevelResourceId: number): Observable<SyllabusLevelResource> {
    return this.http.delete<SyllabusLevelResource>(`${this.apiUrl}/DeleteSyllabusLevelResource/${syllabusLevelResourceId}`);
  }

}
